import React from "react";
import { useSearchParams } from "react-router-dom";
import {Pagination} from "@components";
import { useCompany } from "@hooks";

function CompanyTable({ handleRowClick, selectedId }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const pageIndex = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = 10;

  const queryParam = {
    searchCnd: searchParams.get("searchCnd") || "",
    searchWrd: searchParams.get("searchWrd") || "",
    pageIndex,
    recordCountPerPage,
  };
 
  const { data, selectedItems, isAllChecked, handleSelectAll, handleSelectItem, handleExcelDownload, handleDelete } = useCompany(queryParam);

  const handlePageChange = (targetPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", targetPage);
    setSearchParams(newParams);
  };
  
  return (
  <>  
    <div className="section-tit-wrap">
        <h3 className="border-left-primary">
        &nbsp;업체 목록
        <span className="total-txt">
            {" "} | 총 <span className="red">{data?.totalcount} </span> 건
        </span>
        </h3>
        <div className="btn-box">
            <button type="button" className="btn-excel" onClick={handleExcelDownload}>엑셀</button>
            <button type="button" className="btn-delete" onClick={handleDelete}>삭제</button>
        </div>
    </div>
    <div className="table-container">
        <table className="table-list" style={{ width: "100%" }}>
        <colgroup>
            <col style={{ width: "5%" }} />
            <col style={{ width: "5%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "5%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "15%" }} />
            <col style={{ width: "15%" }} />
        </colgroup>
        <thead>
            <tr>
            <th><input type="checkbox" checked={isAllChecked} onChange={(e) => handleSelectAll(e.target.checked)} /></th>
            <th>No</th>
            <th>사업장명</th>
            <th>사업장관리번호</th>
            <th>대표자명</th>
            <th>전화번호</th>
            <th>업태</th>
            <th>종목</th>
            </tr>
        </thead>
        <tbody>
            {data?.resultList && data.resultList.length > 0 ? (
            data.resultList.map((item, idx) => (
                <tr
                    key={item.bizRegNo}
                    style={{ 
                        backgroundColor:
                        selectedId === item.bizRegNo ? "#f2f2f2" : "",
                        cursor: "pointer" }}
                        onClick={() => handleRowClick(item)} >
                <td>
                    <input  
                        type="checkbox"
                        checked={selectedItems.includes(item.bizRegNo)}
                        onChange={(e) => {
                            e.stopPropagation();
                            handleSelectItem(item.bizRegNo);
                    }} />
                </td>
                <td>{(pageIndex - 1) * recordCountPerPage + idx + 1}</td>
                <td style={{textAlign:"left"}}>{item.companyNm}</td>
                <td>{item.bizRegNo}</td>
                <td>{item.representNm}</td>
                <td>{item.phoneNo}</td>
                <td>{item.bizTypeNm}</td>
                <td>{item.bizItemNm}</td>
                </tr>
            ))
            ) : (
            <tr>
                <td colSpan={9} style={{ textAlign: "center" }}>
                조회 결과가 없습니다.
                </td>
            </tr>
            )}
        </tbody>
        </table>
    </div>
        {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
            <Pagination
                totalPages={Math.ceil(
                data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                )}
                currentPage={pageIndex}
                onPageChange={handlePageChange}
                pageRangeDisplayed={10}
            />
        )}
  </>          
  );
}

export default CompanyTable;
